import once from '../helpers/once';
import shopItem from '../components/shop-item';
import shoppingCart from '../modules/m11-2-shopping-cart';
import pubsub from '../libs/pubsub';

/**
 * @file Handles shop actions
 * @author michael.schmid@notch-interactive.com
 *
 * @module modules/m11-1-shop-item
 * @module modules/m11-2-shopping-cart
 *
 *
 */

const instance = {},

    /**
     *
     * @typedef defaults
     */

    defaults = {
        bodyClass: 'shop',
        cartStepperAttribute: 'data-cart-stepper',
        sidebarCartItem: '.m-sidebar .cart-item',
        eventContainers: '.m-shop, .m-shopping-cart',
        totalValueSidebar: '.m-sidebar [data-cart-total-value]',
        totalValueOverlay: '.m-shop-overlay [data-cart-total-value]',
        cartItemsContainerSidebar: '.cart__items-container',
        cartItemsContainerOverlay: '.overlay .cart__items-container',
        gridSettings: ['col-xs-12', 'col-sm-6', 'col-xl-4'],
        allowedKeys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'],
        shopItemsContainerClass: 'm-shop',
        shopItemAttr: 'data-shop-item',
        cartCheckoutFixedAttr: 'data-cart-checkout-fixed',
        checkoutItemCount: 'data-checkout-item-count',
        shoppingCartAttr: 'data-cart',
        animateClass: 'animate'
    };

let settings,
    shopItemElements,
    cartCheckoutFixed,
    shoppingCartElements,
    shoppingCarts = [],

    itemDeletedHandler = (data) => {

        // Apply cart items to all shopping-cart instances
        shoppingCarts.forEach((shoppingCart) => shoppingCart.applyItems(data.cartItems));

        setCheckoutFixedTotal(data);
    },

    setCheckoutFixedTotal = (data) => {
        if (cartCheckoutFixed) {

            cartCheckoutFixed.querySelector(`[${settings.checkoutItemCount}]`).innerHTML = data.totalAmount;

            // Animate icon
            once(cartCheckoutFixed, 'animationend', () => {
                cartCheckoutFixed.classList.remove(settings.animateClass);
            });

            cartCheckoutFixed.classList.add(settings.animateClass);
        }
    },

    totalCalculatedHandler = (data) => {
        setCheckoutFixedTotal(data);

        shoppingCarts.forEach((sc) => sc.applyItems(data.cartItems));
    },

    addToCart = (item) => {
        pubsub.trigger('shoppingCart.addItem', item);
    };

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object|boolean} Instance of created module.
 */

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    shopItemElements = document.querySelectorAll(`[${settings.shopItemAttr}]`);
    shoppingCartElements = document.querySelectorAll(`[${settings.shoppingCartAttr}]`);

    if (!shopItemElements.length || !shoppingCartElements.length) {
        return;
    }

    cartCheckoutFixed = document.querySelector('[' + settings.cartCheckoutFixedAttr + ']');

    // Listen to shopItem events
    shopItemElements.forEach((el) => {
        shopItem(el).on('addToCart', addToCart);
    });

    // Init shopping-carts (desktop, mobile)
    shoppingCartElements.forEach((el) => {
        let sc = shoppingCart(el);

        // TODO: better use pubsub
        sc.on('subtotalChanged', totalCalculatedHandler);
        sc.on('totalCalculated', setCheckoutFixedTotal);
        sc.on('itemDeleted', itemDeletedHandler);

        sc.applyItems(window.DS.cartItems);

        shoppingCarts.push(sc);
    });

    // Set initial items count
    if (cartCheckoutFixed) {
        cartCheckoutFixed.querySelector(`[${settings.checkoutItemCount}]`).innerHTML = shoppingCarts[0].getTotalAmount();
    }

    // Set body class, so we can handle layout
    document.body.classList.add(settings.bodyClass);

    return instance;
};

export default instance;
